import { lazy, Suspense } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LocaleRoute, useLocale } from "./i18n/LocaleContext";
import { AboutPage } from "./pages/AboutPage";
import { MethodologyPage } from "./pages/MethodologyPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { WindgramPage } from "./pages/WindgramPage";

const HeatmapPage = lazy(() =>
  import("./pages/HeatmapPage").then((module) => ({
    default: module.HeatmapPage
  }))
);

function LoadingRoute() {
  const { t } = useTranslation();
  return <div className="route-loading">{t("map.loading")}</div>;
}

function NotFoundRedirect() {
  const { pathname } = useLocale();
  return <Navigate replace to={pathname("/")} />;
}

function productRoutes() {
  return (
    <>
      <Route index element={<WindgramPage />} />
        <Route
          path="forecast/:countryCode/:regionCode/:siteSlug"
          element={<WindgramPage />}
        />
        <Route
          path="map"
          element={
            <Suspense fallback={<LoadingRoute />}>
              <HeatmapPage />
            </Suspense>
          }
        />
        <Route path="about" element={<AboutPage />} />
        <Route path="methodology" element={<MethodologyPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
      <Route path="*" element={<NotFoundRedirect />} />
    </>
  );
}

function LocaleOutlet() {
  return <Outlet />;
}

export function App() {
  return (
    <Routes>
      <Route element={<LocaleRoute />}>
        {productRoutes()}
      </Route>
      <Route path=":locale" element={<LocaleOutlet />}>
        <Route element={<LocaleRoute prefixed />}>{productRoutes()}</Route>
      </Route>
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}
